import React from 'react';
import { AvatarProps } from './Avatar/Avatar.props';
import { useAvatarState } from './Avatar/Avatar.state';
import { AvatarView } from './Avatar/Avatar.view';
import { useMergedDesignSystemComponentProps } from 'src/design-system';

// Defines the AvatarComponent functional component with destructured props from AvatarProps type.
const AvatarComponent = (props: AvatarProps) => {
  const mergedProps = useMergedDesignSystemComponentProps('avatar', props);
  const { src, size, views, fallback, onClick, children } = mergedProps;
  // Uses custom hook useAvatarState to manage the avatar image loading error state.
  const { imageError, setImageError } = useAvatarState();
  // Begins the JSX return block for rendering the AvatarView component.
  return (
    <AvatarView
      src={src}
      size={size}
      views={views}
      fallback={fallback}
      imageError={imageError}
      setImageError={setImageError}
      onClick={onClick}
    >
      {children}
    </AvatarView>
  );
  // AvatarComponent is a functional component that wraps the AvatarView with added state logic.
};
// Exports the AvatarComponent as Avatar for use in other parts of the application.
export const Avatar = AvatarComponent;
